import { TargetSelector, getLayoutSettingValueSelector, makeBoxShadowStyleSelector } from "@client/selectors";
import { type GenericMap } from "@client/types";
import { createSelector } from "reselect";

const VCA_TO_SELF: GenericMap<string> = {
  full_height: "stretch",
  align_top: "flex-start",
  align_center: "center",
  align_bottom: "flex-end"
};

const boxShadowStyleSelector = makeBoxShadowStyleSelector(TargetSelector.Layout, "body");

const bodyWidthSelector = getLayoutSettingValueSelector("width", "body");
const verticalContentAlignSelector = getLayoutSettingValueSelector("verticalContentAlign", "body");

export const styleSelector = createSelector(
  [bodyWidthSelector, verticalContentAlignSelector, boxShadowStyleSelector],
  (width, vca, boxShadowStyle): React.CSSProperties => ({
    ...boxShadowStyle,
    alignSelf: VCA_TO_SELF[vca],
    display: "flex",
    minWidth: 0,
    margin: "0 auto",
    position: "relative",
    //overflow: "hidden", // BREAKS sticky header!
    // transform: "translateX(0)", // BREAKS fixed positioning when scrolling for side panel
    width: width ?? "100%"
  })
);
